import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import { useSelector } from 'react-redux';
import DetailProduct from './DetailProduct';
import DrinksScreens from './drinks';

function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [appetizers, setappetizers] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [carnte, setcarnte] = useState(false);
    const [dataDrink, setdataDrink] = useState(false);
    const [dataCarne, setdataCarne] = useState(false);
    const [dataMothers, setDataMothers] = useState(false);
     const [showDrinks, setshowDrinks] = useState(false);




     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 479) {
                    setdrinks(item);
                    
                }
                if (item.id === 462) {
                    setappetizers(item);
                }
                 if (item.id === 469) {
                    setcarnte(item);
                }
                if (item.id === 596) {
                    setDataMothers(item);
                }
            });
      }, [menus]);
    
    
     useEffect(() => {
         if (carnte) {
             carnte.menus.map((item) => {
                 if (item.id === 4375) {
                  setdataCarne(item)
                
               }
           })
       }
     }, [carnte]);
    
     useEffect(() => {
         if (drinks) {
             drinks.menus.map((item) => {
                 if (item.id === 4374) {
                     setdataDrink(item)
                     
                
               }
           })
       }
     }, [drinks]);
    
    
    useEffect(() => {
        console.log(goHomeInit, 'q mas qlq')
         setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
        setshowCategories(false)
        setShowDetailProduct(false)
    }, [goHomeInit]);
    


    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            getInitData();

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

    return (
         <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={() => {
            setShowSpecials(true)
        }} goCategories={setshowCategories}>
                <div>
                    
                    <img
                        style={{
                            width: 490,
                            height: 120,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            position: 'relative',
                            marginTop: -10,
                            
                        }}
                        src={require('./assets/672146f26d071.jpg')}
                    />
                
                    <div style={{
                        display: 'flex', width: '90%', margin: '0 auto', position: 'relative',
                        zIndex: 100,boxSizing: 'border-box',
                        marginTop: 10,
                        justifyContent: 'space-evenly',
                      
                     
                       
                    }}>
                       
                    <div style={{ width: '45%',display: 'flex', justifyContent: 'flex-start', alignItems: 'left'}}>
                        <img
                             onClick={() => {
                                // setDataDish({ dish: dataCarne, alldish: carnte.menus})
                                // setShowDetailProduct(true)
                            }}
                            src={require('./assets/BEBIDA.png')}
                            loop autoPlay={true} muted 
                            style={{
                                width: '90%',
                                height: 470,
                                objectFit: 'contain',
                                borderRadius: 14,
                               
                            }}
                        />

                    </div>
                    <div style={{ width: '55%'}}>
                        
                        <img
                            onClick={() => {
                                setshowCategories(true)
                            }}
                            style={{
                                      marginTop: 50,
                                    width: '100%',
                                    objectFit: 'contain',
                                    borderRadius: 14,
                                }}
                                src={require('./assets/FOOD.png')}
                            />

                             <img
                            onClick={() => {
                                setshowDrinks(true)
                            }}
                            style={{
                                      marginTop: 50,
                                    width: '100%',
                                    objectFit: 'contain',
                                    borderRadius: 14,
                                }}
                                src={require('./assets/DRINKShome.png')}
                            />
                    </div>
                </div>

                    <div>
                        
                    <img
                        style={{
                        width: 300,
                        height: 10,
                        resizeMode: 'contain',
                        }}
                        src={require('./assets/image.png')}
                    />
                    </div>
               
                </div>
                
                <div style={{ width: '100%', position: 'relative'}}>
                    
                    <img
                        onClick={() => {
                           // setdishs(dataMothers)
                        //setShowListProduct(true)
                        }}
                        src={require('./assets/bannerh.png')}
                       
                        style={{
                        width: '90%',
                        height: 212,
                            borderRadius: 14,
                        objectFit: 'contain'
                        }}
                    />
                </div>

           
            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
                {showBar && <BarScreen setShowBar={setShowBar} />}
                   {showDrinks && <DrinksScreens setShowListProduct={setshowDrinks} setShowHappy={setshowCategories} />}
            

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}
            
           
      
            
        </LayoutContent>
        </div>
    );
}

export default Index;